import { toast } from 'react-toastify';
import { formatCurrencyToNumber } from '../../helper/publicacionHelper';

export const validationsSubmitRebate = ({ precioFinal, aCargoMegatone, unidades, fechaInicio, fechaVencimiento, unidadesNum, aCargoSeller }) => {
    if (formatCurrencyToNumber(precioFinal) < 0) {
        toast.error("El precio final no puede ser negativo");
        return false;
    }
    if (formatCurrencyToNumber(aCargoMegatone) <= 0 && formatCurrencyToNumber(aCargoSeller) <= 0) {
        toast.error("Al menos uno de los valores debe ser mayor a cero (Megatone o Seller)");
        return false;
    }
    if (formatCurrencyToNumber(unidades) < 0) {
        toast.error("La cantidad de unidades no puede ser negativa");
        return false;
    }

    // 1) Si ambas fechas tienen valor: validar orden y que NO haya unidades
    if (fechaInicio && fechaVencimiento) {
        if (new Date(fechaInicio) >= new Date(fechaVencimiento)) {
            toast.error("La fecha de inicio debe ser menor que la fecha de vencimiento");
            return false;
        }
        if (unidades && unidadesNum > 0) {
            toast.error("Si se ingresan fechas, las unidades deben quedar vacías");
            return false;
        }
    }

    // 2) Si NO hay ninguna fecha: deben existir unidades > 0
    if (!fechaInicio && !fechaVencimiento) {
        if (!unidades || unidadesNum <= 0) {
            toast.error("Debe ingresar ambas fechas o bien las unidades (> 0)");
            return false;
        }
    }

    // 3) Caso restante: hay una sola fecha (con o sin unidades) -> inválido
    if ((fechaInicio && !fechaVencimiento) || (!fechaInicio && fechaVencimiento)) {
        if (unidades && unidadesNum > 0) {
            toast.error("Si se ingresan unidades, las fechas deben estar vacías");
            return false;
        } else {
            toast.error("Debe ingresar ambas fechas");
            return false;
        }
    }

    return true;
}